import React from "react";
import { Typography } from "@material-ui/core";

export const MINAS_GERAIS_LANDING_FAQ = {
  categories: [
    { id: "frequentes", label: "Mais frequentes" },
    { id: "adesao", label: "Adesão em MG" },
    { id: "economia", label: "Economia e cobrança" },
    { id: "operacao", label: "Operação" },
  ],
  entries: [
    {
      question: "Como faço para começar a economizar em Minas Gerais com a Energea?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Basta simular sua economia e enviar a sua conta de luz da CEMIG. A
            análise é feita online, sem custo de adesão e sem necessidade de
            visita técnica.
          </Typography>
          <Typography>
            Após a aprovação do cadastro, você recebe o contrato para assinatura
            eletrônica e passa a participar da nossa usina solar em Minas Gerais.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["frequentes", "adesao"],
    },
    {
      question: "Existe algum custo para aderir?",
      answer: (
        <Typography>
          Não. A adesão é 100% digital e gratuita. Você não paga taxa de
          entrada, implantação, vistoria ou ativação para começar a receber
          créditos de energia.
        </Typography>
      ),
      categoryId: ["frequentes", "adesao"],
    },
    {
      question: "Quem pode contratar em Minas Gerais?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Atendemos empresas e condomínios em Minas Gerais com unidades
            consumidoras atendidas pela CEMIG, dentro das regras aplicáveis à
            geração distribuída.
          </Typography>
          <Typography>
            A conta precisa estar adimplente e em nome do mesmo titular que fará
            a adesão.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["adesao"],
    },
    {
      question: "Como a economia aparece na conta de luz da CEMIG?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Os créditos gerados pela usina solar são compensados na sua conta de
            luz da CEMIG. Eles aparecem na fatura como energia
            injetada/créditos, reduzindo o valor sobre o qual você paga a
            tarifa.
          </Typography>
          <Typography>
            Depois disso, a Energea envia a cobrança referente aos créditos
            recebidos, já com o desconto contratado.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["frequentes", "economia"],
    },
    {
      question: "O desconto é aplicado na conta inteira?",
      answer: (
        <Typography>
          Não. A economia incide sobre o valor dos créditos de energia
          compensados na sua conta. Custos da distribuidora, como
          disponibilidade e encargos, continuam sendo cobrados normalmente pela
          CEMIG.
        </Typography>
      ),
      categoryId: ["economia"],
    },
    {
      question: "Precisa instalar equipamento no meu imóvel?",
      answer: (
        <Typography>
          Não. Toda a infraestrutura fica na usina solar da Energea. O processo
          é remoto e 100% digital, sem obra, sem instalação no telhado e sem
          visita técnica no local.
        </Typography>
      ),
      categoryId: ["frequentes", "operacao"],
    },
    {
      question: "Quando começo a receber os créditos?",
      answer: (
        <Typography>
          Depois da aprovação cadastral e da ativação da sua unidade
          consumidora, os créditos passam a ser refletidos na conta em prazo
          operacional da distribuidora. Nossa equipe acompanha o processo e
          mantém você informado.
        </Typography>
      ),
      categoryId: ["operacao"],
    },
    {
      question: "Existe fidelidade ou taxa escondida?",
      answer: (
        <Typography>
          Não. O contrato não tem taxa de adesão nem cobrança escondida. Se
          você quiser encerrar a participação, basta seguir o prazo contratual
          de aviso prévio informado na adesão.
        </Typography>
      ),
      categoryId: ["frequentes", "adesao"],
    },
  ],
};

export const RIO_DE_JANEIRO_LANDING_FAQ = {
  categories: [
    { id: "frequentes", label: "Mais frequentes" },
    { id: "adesao", label: "Adesão no RJ" },
    { id: "economia", label: "Economia e cobrança" },
    { id: "operacao", label: "Operação" },
  ],
  entries: [
    {
      question:
        "Como faço para começar a economizar no Rio de Janeiro com a Energea?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Basta simular sua economia e enviar a sua conta de luz da Light. A
            análise é feita online, sem custo de adesão e sem necessidade de
            visita técnica.
          </Typography>
          <Typography>
            Após a aprovação do cadastro, você recebe o contrato para assinatura
            eletrônica e passa a participar da nossa usina solar no Rio de Janeiro.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["frequentes", "adesao"],
    },
    {
      question: "Existe algum custo para aderir?",
      answer: (
        <Typography>
          Não. A adesão é 100% digital e gratuita. Você não paga taxa de
          entrada, implantação, vistoria ou ativação para começar a receber
          créditos de energia.
        </Typography>
      ),
      categoryId: ["frequentes", "adesao"],
    },
    {
      question: "Quem pode contratar no Rio de Janeiro?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Atendemos empresas e condomínios no Rio de Janeiro com unidades
            consumidoras atendidas pela Light, dentro das regras aplicáveis à
            geração distribuída.
          </Typography>
          <Typography>
            A conta precisa estar adimplente e em nome do mesmo titular que fará
            a adesão.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["adesao"],
    },
    {
      question: "Como a economia aparece na conta de luz da Light?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Os créditos gerados pela usina solar são compensados na sua conta de
            luz da Light. Eles aparecem na fatura como energia
            injetada/créditos, reduzindo o valor sobre o qual você paga a
            tarifa.
          </Typography>
          <Typography>
            Depois disso, a Energea envia a cobrança referente aos créditos
            recebidos, já com o desconto contratado.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["frequentes", "economia"],
    },
    {
      question: "O desconto é aplicado na conta inteira?",
      answer: (
        <Typography>
          Não. A economia incide sobre o valor dos créditos de energia
          compensados na sua conta. Custos da distribuidora, como
          disponibilidade e encargos, continuam sendo cobrados normalmente pela
          Light.
        </Typography>
      ),
      categoryId: ["economia"],
    },
    {
      question: "Precisa instalar equipamento no meu imóvel?",
      answer: (
        <Typography>
          Não. Toda a infraestrutura fica na usina solar da Energea. O processo
          é remoto e 100% digital, sem obra, sem instalação no telhado e sem
          visita técnica no local.
        </Typography>
      ),
      categoryId: ["frequentes", "operacao"],
    },
    {
      question: "Quando começo a receber os créditos?",
      answer: (
        <Typography>
          Depois da aprovação cadastral e da ativação da sua unidade
          consumidora, os créditos passam a ser refletidos na conta em prazo
          operacional da distribuidora. Nossa equipe acompanha o processo e
          mantém você informado.
        </Typography>
      ),
      categoryId: ["operacao"],
    },
    {
      question: "Existe fidelidade ou taxa escondida?",
      answer: (
        <Typography>
          Não. O contrato não tem taxa de adesão nem cobrança escondida. Se
          você quiser encerrar a participação, basta seguir o prazo contratual
          de aviso prévio informado na adesão.
        </Typography>
      ),
      categoryId: ["frequentes", "adesao"],
    },
  ],
};

export const GOIAS_LANDING_FAQ = {
  categories: [
    { id: "frequentes", label: "Mais frequentes" },
    { id: "adesao", label: "Adesão em GO" },
    { id: "economia", label: "Economia e cobrança" },
    { id: "operacao", label: "Operação" },
  ],
  entries: [
    {
      question: "Como faço para começar a economizar em Goiás com a Energea?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Basta simular sua economia e enviar a sua conta de luz da Equatorial
            Goiás. A análise é feita online, sem custo de adesão e sem
            necessidade de visita técnica.
          </Typography>
          <Typography>
            Após a aprovação do cadastro, você recebe o contrato para assinatura
            eletrônica e passa a participar da nossa usina solar em Goiás.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["frequentes", "adesao"],
    },
    {
      question: "Existe algum custo para aderir?",
      answer: (
        <Typography>
          Não. A adesão é 100% digital e gratuita. Você não paga taxa de
          entrada, implantação, vistoria ou ativação para começar a receber
          créditos de energia.
        </Typography>
      ),
      categoryId: ["frequentes", "adesao"],
    },
    {
      question: "Quem pode contratar em Goiás?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Atendemos empresas e condomínios em Goiás com unidades consumidoras
            atendidas pela Equatorial Goiás, dentro das regras aplicáveis à
            geração distribuída.
          </Typography>
          <Typography>
            A conta precisa estar adimplente e em nome do mesmo titular que fará
            a adesão.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["adesao"],
    },
    {
      question: "Como a economia aparece na conta de luz da Equatorial Goiás?",
      answer: (
        <React.Fragment>
          <Typography gutterBottom>
            Os créditos gerados pela usina solar são compensados na sua conta de
            luz da Equatorial Goiás. Eles aparecem na fatura como energia
            injetada/créditos, reduzindo o valor sobre o qual você paga a
            tarifa.
          </Typography>
          <Typography>
            Depois disso, a Energea envia a cobrança referente aos créditos
            recebidos, já com o desconto contratado.
          </Typography>
        </React.Fragment>
      ),
      categoryId: ["frequentes", "economia"],
    },
    {
      question: "O desconto é aplicado na conta inteira?",
      answer: (
        <Typography>
          Não. A economia incide sobre o valor dos créditos de energia
          compensados na sua conta. Custos da distribuidora, como
          disponibilidade e encargos, continuam sendo cobrados normalmente pela
          Equatorial Goiás.
        </Typography>
      ),
      categoryId: ["economia"],
    },
    {
      question: "Precisa instalar equipamento no meu imóvel?",
      answer: (
        <Typography>
          Não. Toda a infraestrutura fica na usina solar da Energea. O processo
          é remoto e 100% digital, sem obra, sem instalação no telhado e sem
          visita técnica no local.
        </Typography>
      ),
      categoryId: ["frequentes", "operacao"],
    },
    {
      question: "Quando começo a receber os créditos?",
      answer: (
        <Typography>
          Depois da aprovação cadastral e da ativação da sua unidade
          consumidora, os créditos passam a ser refletidos na conta em prazo
          operacional da distribuidora. Nossa equipe acompanha o processo e
          mantém você informado.
        </Typography>
      ),
      categoryId: ["operacao"],
    },
    {
      question: "Existe fidelidade ou taxa escondida?",
      answer: (
        <Typography>
          Não. O contrato não tem taxa de adesão nem cobrança escondida. Se
          você quiser encerrar a participação, basta seguir o prazo contratual
          de aviso prévio informado na adesão.
        </Typography>
      ),
      categoryId: ["frequentes", "adesao"],
    },
  ],
};

export const STATE_LANDING_FAQ_BY_PATH = {
  "/energia-mais-barata-minas-gerais": MINAS_GERAIS_LANDING_FAQ,
  "/energia-mais-barata-rio-de-janeiro": RIO_DE_JANEIRO_LANDING_FAQ,
  "/energia-mais-barata-goias": GOIAS_LANDING_FAQ,
};
